"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var FooterMethods = _interopRequireWildcard(require("./CalculatorPanelFooter"));
var _CalculatorProvider = require("./CalculatorProvider");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _material = require("@mui/material");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Component rendered as "navigate" variant by Calculator Panel Footer
 *
 * @visibleName Navigation Footer
 * @author [Jeff Stevens](mailto:jeffrey.stevens@pheaa.org)
*/
const CalculatorNavigationFooter = props => {
  const {
      backButtonText = "Previous",
      children,
      className,
      disableDefault = false,
      dispatch,
      footerStyles = {},
      hideBack = false,
      hideNavigateButton = false,
      hideReset = true,
      navigateButtonText = "Next",
      onNavigateBack,
      onNavigateForward,
      onReset,
      resetButtonText = "Reset",
      testId
    } = props,
    compositeClasses = (0, _classnames.default)({
      "calculator__panel-actions--isNavigate": true,
      [`${className}`]: className
    }),
    handleNavigateBack = e => FooterMethods.HandleNavigateBack(e, dispatch, onNavigateBack),
    handleNavigateForward = e => FooterMethods.HandleNavigateForward(e, dispatch, onNavigateForward),
    defaultFormState = _CalculatorProvider.Methods.useDefaultFormState(),
    handleReset = e => FooterMethods.HandleReset(e, dispatch, onReset, defaultFormState);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: compositeClasses,
    "data-testid": testId,
    sx: footerStyles
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "calculator__panel-actions--isPrimary"
  }, !hideNavigateButton && /*#__PURE__*/_react.default.createElement(_material.Button, {
    className: "calculator__panel-button calculator__panel-button--isNext",
    onClick: handleNavigateForward,
    disabled: disableDefault,
    variant: "primary"
  }, navigateButtonText), !hideReset && /*#__PURE__*/_react.default.createElement(_material.Button, {
    className: "calculator__panel-button calculator__panel-button--isReset",
    onClick: handleReset,
    variant: "ctalink"
  }, resetButtonText), children), /*#__PURE__*/_react.default.createElement(_material.Box, null, !hideBack && /*#__PURE__*/_react.default.createElement(_material.Button, {
    className: "calculator__panel-button calculator__panel-button--isBack",
    onClick: handleNavigateBack,
    variant: "secondary"
  }, backButtonText)));
};
CalculatorNavigationFooter.propTypes = {
  /** Back button text (Default Value: "Previous") */
  backButtonText: _propTypes.default.string,
  /** Custom child actions fragment/component */
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  /** Optional class name(s) */
  className: _propTypes.default.string,
  /** Boolean to deactive default button (Default Value: false) */
  disableDefault: _propTypes.default.bool,
  /** Dispatch Function */
  dispatch: _propTypes.default.func.isRequired,
  /** Style object for footer component (Default Value: {}) */
  footerStyles: _propTypes.default.object,
  /** Boolean to hide back button (Default Value: false) */
  hideBack: _propTypes.default.bool,
  /** Boolean to hide navigate forward button (Default Value: false) */
  hideNavigateButton: _propTypes.default.bool,
  /** Boolean to hide reset button (Default Value: true) */
  hideReset: _propTypes.default.bool,
  /** Navigate next button text (Default Value: "Next") */
  navigateButtonText: _propTypes.default.string,
  /** Custom navigate back method */
  onNavigateBack: _propTypes.default.func,
  /** Custom navigate next method */
  onNavigateForward: _propTypes.default.func,
  /** Reset button text (Default Value: "Reset") */
  resetButtonText: _propTypes.default.string,
  /** @ignore */
  testId: _propTypes.default.string
};
var _default = exports.default = CalculatorNavigationFooter;